"use client"
import { useEffect, useRef } from "react"
import Slider from "../Slider/Slider"
import HeroSection from "../Hero/HeroSection"
import IntermediateHero from "./IntermediateHero"
import "./LandingPage.css"
import fondo from "../../assets/15.png"

function LandingPage() {
  const heroSectionRef = useRef(null)

  useEffect(() => {
    const handleScroll = () => {
      if (heroSectionRef.current && window.intermediateLayerRef) {
        const heroRect = heroSectionRef.current.getBoundingClientRect()
        const windowHeight = window.innerHeight

        // Calcula qué porcentaje del hero está visible
        const heroVisiblePercent = 1 - heroRect.bottom / (heroRect.height + windowHeight)

        // Comienza a mostrar la capa intermedia cuando estás a 95% del hero
        if (heroVisiblePercent > 0.95) {
          // Limita la transformación para que no oculte el footer
          // Reducimos el valor máximo de translateY para dejar espacio al footer
          const translateY = Math.min(80, (heroVisiblePercent - 0.95) * 2000)
          window.intermediateLayerRef.current.style.transform = `translateY(-${translateY}%)`
        } else {
          window.intermediateLayerRef.current.style.transform = "translateY(0)"
        }
      }
    }

    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  return (
    <div className="landing-page">
      <Slider />
      <div className="parallax-section">
        <div className="parallax-background"></div>

        <div ref={heroSectionRef}>
          <HeroSection />
        </div>

        {/* Componente de capa intermedia antes del footer */}
        <IntermediateHero backgroundImage={fondo.src} />

        {/* No agregues el Footer aquí, ya está en App.js */}
        {/* Agregamos un espacio para el footer */}
        <div className="footer-spacer"></div>
      </div>
    </div>
  )
}

export default LandingPage

